export default __webpack_public_path__ + "static/media/table_login_ver2.65404184.png";